// removed by extract-text-webpack-plugin
module.exports = {"root":"_2jLvB","strip":"cmJGX","person":"_1c4Dw"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/People/pages/Index.sass
// module id = ./src/modules/People/pages/Index.sass
// module chunks = 6